<template>
  <v-card>
    <v-toolbar flat>
      <b>Edit Reference</b>
    </v-toolbar>
    <v-container fluid>
      <EditorComponent :html="ref" for-reference @done="c => (this.ref = c)" />
      <div class="mt-3">Following slides will be updated:</div>
      <div v-if="item.slides.length === 0" class>No slides assigned</div>
      <slide-link
        :is-loading="id === activeLoadingSlide"
        class="mr-1 mt-1"
        chip
        v-else
        :sid="id"
        v-for="id in item.slides"
        :key="id"
      />
      <!-- <v-chip-group
        v-else
        column
      >
        <v-chip
          v-for="(slide, index) in item.slides"
          :key="slide._id"
          class="chip"
          :style="`background-color: var(--${slide.status});`"
        >
          <v-progress-circular
            v-if="loading[index] === true"
            dark
            indeterminate
          />
          <v-icon v-if="success[index] === true">
            {{ icons.done }}
          </v-icon>
          <div class="chip">
            {{ slide.externalId }}
          </div>
        </v-chip>
      </v-chip-group>-->
    </v-container>
    <v-card-actions>
      <v-spacer />
      <v-btn depressed @click="$emit('close')">Close</v-btn>
      <v-btn v-if="!success" :loading="loading" color="primary" depressed @click.prevent="updateReference"
        >Update Reference</v-btn
      >
      <v-btn v-else color="success" depressed @click="cleanUp">Done</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { UPDATE_REFERENCE } from '@/config/constants';
// import IndesignService from '@/services/modules/indesign';
import Vue from 'vue';
import EditorComponent from '@/components/editor/EditorComponent';
import icons from '../../mixins/icons';
import ReferenceTileSlideLink from '../references/ReferenceTileSlideLink.vue';

export default {
  name: 'EditReferenceDialog',
  components: { EditorComponent, slideLink: ReferenceTileSlideLink },
  mixins: [icons],
  props: {
    item: Object
  },
  data() {
    return {
      ref: this.item.text,
      loading: false,
      success: false,
      activeLoadingSlide: null
    };
  },
  methods: {
    async updateReference() {
      this.loading = true;
      this.item.text = this.ref;
      try {
        await this.$store.dispatch(UPDATE_REFERENCE, this.item).then(async () => {
          if (this.item.slides.length > 0) {
            await this.updateSlides();
          } else {
            this.$emit('close');
          }
        });

        this.success = true;
      } catch (error) {
      } finally {
        this.isLoading = false;
      }
    },
    async updateSlides() {
      return Promise.all(
        this.item.slides.map(async (s, i) => {
          this.activeLoadingSlide = s;
          const { IndesignService } = require('@/services/modules/indesign');
          return await new IndesignService().reloadReferenceSlide(s);
        })
      );
    },
    cleanUp() {
      this.loading = false;
      this.success = false;
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.chip {
  color: white !important;
}
</style>
